import { type FC, useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { useAppSelector } from '@/redux/store';

import { type TutorialDialogType } from './config';
import { useTutorial } from './context';

interface TutorialRule {
  path: string;
  level: number;
  dialog: TutorialDialogType;
  storageKey: string;
}

const rules: TutorialRule[] = [
  {
    path: AppRoute.DICE_GAME,
    level: 3,
    dialog: 'roll-craft-tutorial',
    storageKey: 'tutorialRollCraft',
  },
  {
    path: AppRoute.SHOP,
    level: 4,
    dialog: 'shop-tutorial',
    storageKey: 'tutorialShop',
  },
  {
    path: AppRoute.PARTNERS,
    level: 5,
    dialog: 'partners-tutorial',
    storageKey: 'tutorialPartners',
  },
];

const TutorialHooks: FC = () => {
  const { pathname } = useLocation();
  const userId = useAppSelector((state) => state.user.user?.id);
  const userLevel = useAppSelector((state) => state.user.user?.level);
  const { activeDialog, setActiveDialog } = useTutorial();

  useEffect(() => {
    if (!userId || activeDialog) return;

    const matched = rules.find(
      (rule) =>
        matchPath({ path: rule.path }, pathname) && rule.level === userLevel,
    );

    if (!matched) return;

    if (localStorage.getItem(matched.storageKey) === String(userId)) return;

    localStorage.setItem(matched.storageKey, String(userId));
    setActiveDialog(matched.dialog);
  }, [pathname, userLevel, userId, activeDialog, setActiveDialog]);

  return null;
};

export { TutorialHooks };
